import { cutFolder } from "./folder_state";

const headers = new Headers({
  "Content-Type": "application/x-www-form-urlencoded",
});

export default class {
  constructor(baseUrlValue) {
    this.baseUrlValue = baseUrlValue;
  }

  async folders() {
    const response = await fetch(this.baseUrlValue);
    return await response.json();
  }

  async create(parentId, name) {
    const response = await fetch(this.baseUrlValue, {
      method: "POST",
      headers,
      body: new URLSearchParams({ parentId, name }),
    });
    const json = await response.json();
    const [state, folder] = cutFolder(json, json.nextId - 1);
    return folder;
  }

  async rename(folderId, name) {
    const response = await fetch(`${this.baseUrlValue}/${folderId}`, {
      method: "POST",
      headers,
      body: new URLSearchParams({ name }),
    });
    const json = await response.json();
  }

  async move(folderId, parentId) {
    const response = await fetch(`${this.baseUrlValue}/${folderId}`, {
      method: "POST",
      headers,
      body: new URLSearchParams({ parentId }),
    });
    const json = await response.json();
  }

  async delete(folderId) {
    const response = await fetch(`${this.baseUrlValue}/${folderId}`, {
      method: "DELETE",
      headers,
    });
    const json = await response.json();
  }

  async addDocumentToFolder(folderId, folderName, documentId, documentType) {
    const response = await fetch(`${this.baseUrlValue}/${folderId}/documents`, {
      method: "POST",
      headers,
      body: new URLSearchParams({ documentId, documentType, folderName }),
    });
    await response.text();
  }
}
